import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  from: string
  to: string
  isFixed?: boolean
  newVersion?: boolean
}

const BreakHourRange = ({ from, to, isFixed, newVersion }: Props) => {
  const [open, toggle] = useToggle(false)
  const newVersionIcon = isFixed ? 'lock-locked' : 'lock-unlocked'
  const icon = newVersion ? newVersionIcon : 'split'

  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      <Tooltip.Alt
        attachment="bottom center"
        open={open}
        toggle={toggle}
        label={i18n.t('shift_management.planned_breaks.tooltips.range')}
      >
        <Icon.Medium icon={icon} color="grey800" />
      </Tooltip.Alt>
      <Text size="100" color="grey1000">
        {i18n.t('shift_management.planned_breaks.range', { from, to })}
      </Text>
    </Box>
  )
}

export default observer(BreakHourRange)
